import "rxjs"
import {ajax} from "rxjs/observable/dom/ajax"
import config from "../config"
import errorHandlerBuilder from "./errorHandlerBuilder"
import {
  ACTION_UPDATE_LICENSE_ERROR,
  ACTION_UPDATE_LICENSE_LOADED,
  ACTION_UPDATE_LICENSE_LOADING, EVENT_CONSUMER_ACCOUNT_UPDATED,
  PATH_LICENSES
} from "../constants"

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_UPDATE_LICENSE_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_UPDATE_LICENSE_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'PUT',
        url: `${api_server_host}${PATH_LICENSES}/${action.payload.id}`,
        headers: {
          Authorization: `${type} ${token}`,
          'Content-Type': 'application/json'
        },
        body: action.payload,
        responseType: 'json'
      }).map(data=> {
        var payload = data.response
        payload.message = 'Update Successful'
        return {
          type: ACTION_UPDATE_LICENSE_LOADED, payload: payload
        }
      }).rxEmit(EVENT_CONSUMER_ACCOUNT_UPDATED).catch(errorHandler)

    })
export default epic




// WEBPACK FOOTER //
// ./src/epics/UpdateLicenseEpic.js